export const GET_USER_VIEWABLE_PROJECTS_START = "GET_USER_VIEWABLE_PROJECTS_START";
export const GET_USER_VIEWABLE_PROJECTS_SUCCESS = "GET_USER_VIEWABLE_PROJECTS_SUCCESS";
export const GET_USER_VIEWABLE_PROJECTS_FAIL = "GET_USER_VIEWABLE_PROJECTS_FAIL";
